export const createYearOptions = (startYear, endYear = getCurrentYear()) => {
  // Takes start year and endyear which defaults to the current year if not provided then creates an array of integers sorted descending
  let yearOptions = Array(endYear - startYear + 2) // we add 2 - one for a 0 index start and another one to show next year model cars
    .fill()
    .map((_, idx) => startYear + idx)
    .sort((a, b) => b - a)
  // Convert to object type for usage in select dropdown from bootstrap vue
  yearOptions = yearOptions.map((year) => ({
    text: year.toString(),
    value: year.toString(),
  }))
  // Insert null value for select dropdown in beginning of array
  yearOptions.unshift({ text: 'Year', value: null, disabled: true })
  return yearOptions
}

export const createCardYearOptions = (
  startYear,
  endYear = getCurrentYear()
) => {
  // Takes start year and endyear which defaults to the current year if not provided then creates an array of integers
  let yearOptions = Array(endYear - startYear + 1) // we add 1 for a 0 index start
    .fill()
    .map((_, idx) => startYear + idx)
  // Convert to object type for usage in select dropdown from bootstrap vue
  yearOptions = yearOptions.map((year) => ({
    text: year.toString(),
    value: year,
  }))
  // Insert null value for select dropdown in beginning of array
  yearOptions.unshift({ text: 'Year', value: null })
  return yearOptions
}

export const getCurrentYear = () => {
  return new Date().getFullYear()
}
